import { TurretActor } from "./TurretActor";
import * as Anuto from "../../../../engine/src";
import { AudioManager } from "../../../AudioManager";

export class RocketsTurretActor extends TurretActor {

    private f: number;
    private animBase: boolean;

    constructor(scene: Phaser.Scene, position: {r: number, c: number}, turret: Anuto.Turret) {

        super(scene, Anuto.GameConstants.TURRET_ROCKETS, position, turret, "texture_atlas_2", false);

        this.f = 0;
        this.animBase = true;

        this.base.setFrame("torre_5_" + turret.level + "_01");
        this.base.setOrigin(.5, .75);
    }

    public upgrade(): void {

        super.upgrade();

        if (this.animBase) {
            this.base.setFrame("torre_5_" + this.anutoTurret.level + "_01");
        } else {
            this.base.setFrame("torre_5_" + this.anutoTurret.level + "_15");
        }
    }

    public update(time: number, delta: number): void {

        super.update(time, delta);

        if (this.anutoTurret.constructing) {
            return;
        }
        
        if (this.animBase) {

            if (this.f++ === 10) {
                this.base.anims.play("torre_5_" + this.anutoTurret.level);
                AudioManager.playSound("rocket_rise");
                this.animBase = false;
                this.f = 0;
            }
        }
    }

    public shootMortar(): void {
        
        this.base.setFrame("torre_5_" + this.anutoTurret.level + "_01"); 
        this.animBase = true;
    }
}
